<template>
  <div :class="['form-group form-group--icon', {'has-warning': hasError}]">
    <input
      v-on="$listeners"
      v-model="__modelValue"
      class="form-group__textfield"
      :class="[ !hasError ? 'has-success' : 'has-warning' ]"
      :placeholder="__placeholder"
      :type="inputType"
    />

    <i class="icon-lock"></i>

    <span class="password-toggle" @click="handleToggleInputType">
      <i :class="['fi', eyeIconClass]"></i>
    </span>

    <span
      v-show="hasError && __errorMessage"
      class="form-group__feedback"
    >
      {{ __errorMessage }}
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'PasswordFormInput',
  emits: ['update:modelValue'],
  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      inputType: 'password',
    };
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    __modelValue: {
      get () {
        return this.modelValue;
      },
      set (value) {
        this.$emit('update:modelValue', value);
      },
    },
    __errorMessage () {
      return this.getTranslations[this.errorMessage];
    },
    __placeholder () {
      return this.getTranslations[this.placeholder];
    },
    eyeIconClass () {
      return (this.inputType === 'password') ? 'fi-rr-eye-crossed' : 'fi-rr-eye';
    },
  },
  methods: {
    handleToggleInputType () {
      this.inputType = (this.inputType === 'password') ? 'text' : 'password';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/PasswordFormInput.vue